/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Unpublish_Done_Website_OnlyInputs */

const cs_property_unpublish_done_website_only = /** @type {(inputs: Property_Unpublish_Done_Website_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skryto na webu.`)
};

const en_property_unpublish_done_website_only = /** @type {(inputs: Property_Unpublish_Done_Website_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden on the website.`)
};

/**
* | output |
* | --- |
* | "Hidden on the website." |
*
* @param {Property_Unpublish_Done_Website_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_unpublish_done_website_only = /** @type {((inputs?: Property_Unpublish_Done_Website_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Unpublish_Done_Website_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_unpublish_done_website_only(inputs)
	return cs_property_unpublish_done_website_only(inputs)
});